/**
 * Навигация §58 (desktop) и §59 (mobile).
 * Разделы MVP — §78.
 */
import {
  Coins,
  Home,
  Image,
  Layers,
  Palette,
  Settings,
  Sparkles,
  UserRound,
  Users,
  Video,
} from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export interface NavItem {
  to: string;
  /** Ключ перевода, а не текст: список навигации — данные, а не разметка. */
  labelKey: string;
  icon: LucideIcon;
}

/** Основной блок sidebar (§58). */
export const primaryNav: NavItem[] = [
  { to: '/', labelKey: 'nav.home', icon: Home },
  { to: '/projects', labelKey: 'nav.projects', icon: Video },
  { to: '/looks', labelKey: 'nav.looks', icon: Sparkles },
  { to: '/style', labelKey: 'nav.style', icon: Palette },
  { to: '/media', labelKey: 'nav.media', icon: Image },
];

export const personaNav: NavItem[] = [{ to: '/persona', labelKey: 'nav.persona', icon: UserRound }];

/** Нижний блок sidebar (§58). */
export const secondaryNav: NavItem[] = [
  { to: '/referral', labelKey: 'nav.referral', icon: Users },
  { to: '/balance', labelKey: 'nav.balance', icon: Coins },
  { to: '/settings', labelKey: 'nav.settings', icon: Settings },
];

/** Мобильный приоритет §59: создать → проекты → медиа → персона → меню. */
export const mobileNav: NavItem[] = [
  { to: '/create', labelKey: 'nav.create', icon: Layers },
  { to: '/projects', labelKey: 'nav.projects', icon: Video },
  { to: '/media', labelKey: 'nav.media', icon: Image },
  { to: '/persona', labelKey: 'nav.personaShort', icon: UserRound },
];
